import React from "react";
import {
  Grid,
  FormControlLabel,
  Switch,
  Checkbox,
  Button,
  Chip,
  TextField,
} from "@material-ui/core";
import OneButtonDialog from "../../../common/dialogs/one-button-dialog/one-button-dialog";

const AddSubherd = (props) => {
  const [peninput, setPeninput] = React.useState("");
  const [iserror, seterrordialog] = React.useState(false);
  const [errormessage, seterrormessage] = React.useState("");

  const addPen = () => {
    const trimmed = peninput.trim();
    const currentPens = props.addsubherd.Pens || [];
    if (trimmed === "" || !/^[1-9][0-9]*$/.test(trimmed)) {
      seterrormessage("Please enter a valid pen number.");
      seterrordialog(true);
      return;
    }
    if (currentPens.includes(trimmed)) {
      seterrormessage("This pen has already been added.");
      seterrordialog(true);
      return;
    }
    props.setAddsubherd({
      ...props.addsubherd,
      Pens: [...currentPens, trimmed],
    });
    setPeninput("");
  };

  const deletePen = (pen) => {
    props.setAddsubherd({
      ...props.addsubherd,
      Pens: (props.addsubherd.Pens || []).filter((p) => p !== pen),
    });
  };

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <h1 className="appbar-headline text-uppercase">Add A Sub Herd</h1>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          className="text-bold"
          style={{ marginBottom: "15px" }}
          control={
            <Switch
              onChange={() => {
                props.setAddsubherd({ ...props.addsubherd, active: true });
              }}
              checked={props.activeflag}
            ></Switch>
          }
          label={
            props.activeflag
              ? "This Sub-Herd is Active"
              : "This Sub-Herd is Inactive"
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          aria-label="description"
          placeholder="Enter a Description"
          value={props.addsubherd.description}
          onChange={(event) => {
            props.setAddsubherd({
              ...props.addsubherd,
              description: event.target.value,
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          className="text-bold"
          style={{ marginBottom: "15px" }}
          disabled={
            props.herddata.software_herd_software === "PCDART" ||
            props.herddata.parlor_daily_milk_weights === false
          }
          control={
            <Switch
              checked={props.addsubherd.use_avg_daily_milk}
              className="text-bold"
              onChange={() => {
                props.setAddsubherd({
                  ...props.addsubherd,
                  use_avg_daily_milk: !props.addsubherd.use_avg_daily_milk,
                });
              }}
            ></Switch>
          }
          label="Use average daily milk for production calculations"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          className="text-bold"
          style={{ marginBottom: "15px" }}
          disabled={props.herddata.use_ecm_peer_avg === false}
          control={
            <Switch
              checked={props.addsubherd.use_ecm_peer_avg}
              className="text-bold"
              onChange={() => {
                props.setAddsubherd({
                  ...props.addsubherd,
                  use_ecm_peer_avg: !props.addsubherd.use_ecm_peer_avg,
                });
              }}
              name="checkedECM"
            ></Switch>
          }
          label="Use ECM for peer average calculations"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          className="text-bold"
          style={{ marginBottom: "15px" }}
          disabled={
            props.herddata.software_herd_software === "PCDART" ||
            props.herddata.software_herd_software === "DRMS"
          }
          control={
            <Switch
              checked={props.addsubherd.use_full_milk_weeks || false}
              className="text-bold"
              onChange={() => {
                props.setAddsubherd({
                  ...props.addsubherd,
                  use_full_milk_weeks: !props.addsubherd.use_full_milk_weeks,
                });
              }}
              name="useFullMilkWeeks"
            ></Switch>
          }
          label="Use full milk weeks for lactation curves"
        />
      </Grid>

      <Grid item xs={12}>
        <h3>Breeds</h3>
        <p>
          Breed selection will determine both default sub-herd goals and peer
          group filters. You will be able to customize goals by breed or for
          each sub-herd. Herds with any combination of breeds including Holstein
          or Crossbred will be assigned to Holstein-based peer groups. Herds
          with only Jersey and/or Other Purebred will be assigned to
          Jersey-based peer groups
        </p>
      </Grid>
      <Grid container>
        {props.breeds.map((data, index) => {
          return (
            <Grid item xs={6} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(event) => {
                      let tempbreed = props.addsubherd.breeds;
                      if (tempbreed.includes(data.name)) {
                        if (!event.target.checked) {
                          tempbreed = tempbreed.filter((tempbreed) => {
                            return data.name !== tempbreed;
                          });
                        }
                      } else {
                        if (event.target.checked) {
                          tempbreed = [...tempbreed, data.name];
                        }
                      }
                      props.setAddsubherd({
                        ...props.addsubherd,
                        breeds: tempbreed,
                      });
                    }}
                    name={data.name}
                    color="primary"
                    checked={props.addsubherd.breeds.includes(data.name)}
                  />
                }
                label={data.name === "Other" ? "Other Purebred" : data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      {props.herddata.software_herd_software === "DRMS" ? (
        <Grid item xs={12}>
          <h3>Pens</h3>
          <p>Please enter numbers only. If all pens are included, leave it blank.</p>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Enter a Pen"
                value={peninput}
                onChange={(event) => {
                  setPeninput(event.target.value.replace(/[^0-9]/g, ""));
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    addPen();
                  }
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                className="button"
                type="button"
                size="small"
                fullWidth
                onClick={addPen}
              >
                Add
              </Button>
            </Grid>
          </Grid>
          {(props.addsubherd.Pens || []).length > 0 && (
            <Grid item xs={12} style={{ marginTop: "10px" }}>
              {props.addsubherd.Pens.map((pen) => (
                <Chip
                  key={pen}
                  label={pen}
                  onDelete={() => deletePen(pen)}
                  style={{ marginRight: "8px", marginBottom: "8px" }}
                />
              ))}
            </Grid>
          )}
        </Grid>
      ) : null}
      {iserror ? (
        <OneButtonDialog
          content={errormessage}
          open={iserror}
          handleClose={() => {
            seterrordialog(false);
          }}
          btnText1="OK"
          handleActionBtn1={() => {
            seterrordialog(false);
          }}
        />
      ) : null}
    </React.Fragment>
  );
};

export default AddSubherd;
